<div class="col-md-12">
    <!--<h2>BunnyCRM Marketing</h2>-->
    <p>BunnyCRM Marketing runs campaigns end-to-end, so they execute consistently at scale instead of
        depending on manual sends. Every workflow, segment, and campaign shares the same contact record your
        sales team is already working from, so a lead never gets a message that contradicts what your sales
        team just told them.
    </p>
    <h3>Key Features</h3>
    <ul>
        <li><strong>Email Workflows:</strong> Multi-step email sequences triggered by what a contact does, not a manual send.</li>
        <li><strong>Audience Segmentation:</strong> Group contacts by behavior, source, or lifecycle stage for targeted messaging.</li>
        <li><strong>Campaign Management:</strong> Plan, schedule, and track campaigns across channels from a single dashboard.</li>
        <li><strong>Lead Nurturing:</strong> Drip campaigns tied to engagement automatically move prospects further down the funnel.</li>
        <li><strong>Performance Analytics:</strong> Open rates, click-throughs, and conversions tracked back to individual campaigns.</li>
    </ul>
</div>
